import { jsNode } from '@shared/node-v1.0.0'

import v010 from '@nodes/use-hierarchy-v0.1.0'
import v020 from '@nodes/use-hierarchy-v0.2.0'

export default jsNode(
	'useHierarchy',
	{
		'v0.1.0': v010,
		'v0.2.0': v020,
	},
	{ docs: '' }
)
